var React = require('react');

function Four (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"#1DB4FF","d":"M35.27 27.66c-5.36 5.51-13.33 6.17-19.56 3.28 0 0-.45-1.11-.83-.74l-8.25 8.26c-1.64 1.64-3.94 2.03-5.4.87l-.25-.55c-.5-1.46-.08-3.56.57-5.4l8.27-8.27c.37-.36.1-.81.1-.81-3.74-5.59-2.93-13.31 2.43-19.56a16.22 16.22 0 0122.92 0c6.32 6.83 6.32 16.6 0 22.92zm-3-19.93c-4.66-4.11-12.12-4.11-16.92 0a11.99 11.99 0 1016.93 0zm-4.93 2.67a7.2 7.2 0 00-9.42 3.81c-.27.64-.6 1.03-1.54 1.03a1.67 1.67 0 01-1.54-2.33c2.26-5.35 8.45-7.36 13.8-5.6a1.67 1.67 0 11-1.3 3.09z"}));
}

Four.defaultProps = {"viewBox":"0 0 41 40","height":"100%","width":"100%"};

module.exports = Four;

Four.default = Four;
